import React from 'react';
import { Box, Typography } from '@mui/material';
import { HelpIconButton, HelpIconButtonProps } from '../help/HelpIconButton';

export interface PageHeaderProps {
  /** Page title */
  title: React.ReactNode;
  /** Optional help icon next to the title */
  helpAction?: Pick<HelpIconButtonProps, 'onClick'> & { testId?: string };
  /** Custom actions rendered on the right side */
  actions?: React.ReactNode;
  /** Test ID for the component */
  'data-testid'?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  helpAction,
  actions,
  'data-testid': testId,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 36,
        py: 0.5,
        px: { xs: 2, sm: 3 },
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
      data-testid={testId}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          minWidth: 0,
          overflow: 'hidden',
          flex: 1,
        }}
      >
        <Typography
          variant="body1"
          component="h1"
          sx={{ fontWeight: 500, minWidth: 0, overflow: 'hidden', flex: 1 }}
        >
          {title}
        </Typography>
        {helpAction && (
          <HelpIconButton
            onClick={helpAction.onClick}
            data-testid={helpAction.testId}
          />
        )}
      </Box>

      {actions && (
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          {actions}
        </Box>
      )}
    </Box>
  );
};
